<script setup lang="ts">
import { PButton } from '@ui/components/core/p-button/index.js';
import { cn } from '@ui/lib/utils.js';
import { computed, type HTMLAttributes } from 'vue';
import {
    IconLayoutSidebarLeftCollapse,
    IconLayoutSidebarLeftExpand,
    IconLayoutSidebarRightCollapse,
    IconLayoutSidebarRightExpand,
} from '@tabler/icons-vue';

interface PSidePanelTriggerProps {
    side?: 'left' | 'right';
    isOpen?: boolean;
    class?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<PSidePanelTriggerProps>(), {
    side: 'left',
    isOpen: false,
});

const icon = computed(() => {
    if (props.side === 'left') {
        return props.isOpen ? IconLayoutSidebarLeftCollapse : IconLayoutSidebarLeftExpand;
    } else {
        return props.isOpen ? IconLayoutSidebarRightCollapse : IconLayoutSidebarRightExpand;
    }
});
</script>

<template>
    <div :class="cn('p-1', props.class)">
        <PButton variant="ghost" size="icon-sm">
            <component :is="icon"></component>
        </PButton>
    </div>
</template>
